export default __webpack_public_path__ + "static/media/1667.7392fdfd.png";